const teamSearch = () => {
  const input = document.querySelector(".js-team-search");
  const container = document.querySelector(".js-team-container");

  if (!input) {
    return;
  }

  input.addEventListener("keyup", () => {
    let value = input.value;
    fetchData(value);
    if (value.length == 0) {
      fetchData(value, true);
    }
  });
  input.addEventListener("focus", () => {
    let value = input.value;
    if (value.length > 2) {
      fetchData(value);
    }
  });

  async function fetchData(value, reset = false) {
    let formData = new FormData();
    if (reset) {
      formData.append("action", "searchQueryReset");
    } else {
      formData.append("action", "searchQueryAjax");
    }
    formData.append("search", value);

    const response = await fetch(ajaxurl, {
      method: "POST",
      body: formData,
    });

    const data = await response.json();
    container.innerHTML = data.files;
  }
};

export default teamSearch;
